<template>
  <div class="collectCourse">
    <commonHeader :title="'收藏课程'"></commonHeader>
    <userCenterTable
      :isShowLoading="isShowLoading"
      :tableData="tableData"
      :totalCount="totalCount"
      :pageSize="params.pageSize"
      :pageNumber="params.pageNumber"
      :field-data="fieldData"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:specialTitle="scope">
        <span style="cursor: pointer;" @click="goDetail(scope.data)">{{scope.data.specialTitle}}</span>
      </template>
    </userCenterTable>
  </div>

</template>

<script>
import { baseContent } from '../mixin/baseContent'
export default {
  name: 'CollectCourse',
  mixins: [baseContent],
  data() {
    return {
      dataUrl: '/front/userCenter/collectSpecialCourse',
      fieldData: [
        {
          field: 'specialTitle',
          label: '课程名称',
          width: '500',
          type: 'customize'
        },
        {
          field: 'inputTime',
          label: '收藏时间',
          width: '270',
          type: 'text'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    goDetail(data) {
      this.$router.push({
        path: '/courseMain',
        query: {
          pkid: data.pkid,
          pathList: JSON.stringify([
            {
              name: '个人中心',
              path: this.$route.fullPath
            }
          ])
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.collectCourse {
  position: relative;
  height: 755px;
}
</style>
